import { useCode } from '@/hooks/use-code';
import useGlobalStore from '@/stores/global.store';
import * as React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

// Swish opens the callback URL in the device's default browser, which may not be the one the
// payment started in, so the order and payment ids come from the URL rather than the persisted store.
export default function PaymentCallback() {
  const code = useCode();
  const [searchParams] = useSearchParams();
  const restore = useGlobalStore((state) => state.restore);

  const orderId = searchParams.get('orderId');
  const paymentId = searchParams.get('paymentId');
  const isValid = Boolean(orderId && paymentId);

  React.useLayoutEffect(() => {
    if (isValid) restore(orderId!, paymentId!);
  }, [isValid, orderId, paymentId]);

  if (!isValid) return <Navigate to={`/${code}/products`} replace />;

  return <Navigate to={`/${code}/checkout`} replace state={{ returnedFromPaymentId: paymentId }} />;
}

export function LegacyPaymentCallback() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  if (!code) return <Navigate to="/" replace />;

  searchParams.delete('code');

  return <Navigate to={`/${code}/callback?${searchParams.toString()}`} replace />;
}
